export { default } from './useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/useMediaQuery/index.js
// module id = 170
// module chunks = 0